'use client';
import { Span } from 'themes/jumbo/@jumbo/shared';
import { SxProps, Theme } from '@mui/material';
import Popover from '@mui/material/Popover';
import React from 'react';
import { useEffect } from "react";
import EventsEmitter from "events/EventsEmitter";

type JumboDdPopoverProps = {
  hidePopup:boolean, 
  children: React.ReactNode;
  triggerButton: React.ReactNode;
  sx?: SxProps<Theme>;
};

const JumboDdPopover = ({
  hidePopup,
  triggerButton,
  children,
  sx,
}: JumboDdPopoverProps) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const isOpen = Boolean(anchorEl);

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      !hidePopup && setAnchorEl(event.currentTarget);
    },
    []
  );

  const handleClose = React.useCallback(() => {
    setAnchorEl(null);
  }, []);


  useEffect(() => {
      EventsEmitter.on("closeProfilePanel", handleClose);
  });
  

  return (
    <>
      <Span onClick={handleClick} sx={sx}>
        {triggerButton}
      </Span>
      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{
          mt: 2,
          mr: 6,
          width: 850
        }}
      >
        {children}
      </Popover>
    </>
  );
};

export { JumboDdPopover };
